let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d78ma")).then(() => parcelRequire('4K7Z0'));